import React from "react";
import { motion } from "framer-motion";

// Animated network / data-stream SVG background for dark tech sections
export const TechLines = ({ className = "" }) => {
  const nodes = [
    [10, 20], [30, 60], [50, 25], [70, 70], [90, 35], [45, 85], [80, 15], [20, 80],
  ];
  const links = [[0, 2], [2, 4], [4, 6], [1, 3], [3, 5], [0, 1], [2, 3], [4, 7], [1, 7]];
  return (
    <svg className={`absolute inset-0 h-full w-full ${className}`} preserveAspectRatio="none" viewBox="0 0 100 100">
      <defs>
        <linearGradient id="ln" x1="0" x2="1">
          <stop offset="0%" stopColor="#14B877" stopOpacity="0.1" />
          <stop offset="50%" stopColor="#14B877" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#D4AF37" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      {links.map(([a, b], i) => (
        <motion.line
          key={i}
          x1={nodes[a][0]} y1={nodes[a][1]} x2={nodes[b][0]} y2={nodes[b][1]}
          stroke="url(#ln)" strokeWidth="0.25"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 2, delay: i * 0.15 }}
        />
      ))}
      {nodes.map(([x, y], i) => (
        <motion.circle
          key={i} cx={x} cy={y} r="0.8" fill="#14B877"
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 3, delay: i * 0.3, repeat: Infinity }}
        />
      ))}
    </svg>
  );
};
